<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <navcigation-bar :key="merchantInfoKey"></navcigation-bar>
    <div class="main-container">
      <sidebar class="sidebar-container" />
      <!-- <navbar /> -->
      <!-- <tabs-view /> -->
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TabsView, NavcigationBar } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TabsView,
    NavcigationBar
  },
  mixins: [ResizeMixin],
  computed: {
    isCollapse() {
      return !this.sidebar.opened
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    merchantInfoKey() {
      // 使用 merchantId 作为 key，当切换账号时强制组件重新渲染
      const merchantInfo = this.$store.state.MerchantMe.merchantInfo
      return merchantInfo && merchantInfo.merchantId ? merchantInfo.merchantId : 'no-merchant'
    }
  },
  watch: {
    // 监听 merchantInfo 变化，确保导航栏组件能正确更新
    '$store.state.MerchantMe.merchantInfo': {
      handler(newVal, oldVal) {
        // 当 merchantInfo 变化时，强制更新
        this.$forceUpdate()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

// .fixed-header {
//   position: fixed;
//   top: 0;
//   right: 0;
//   z-index: 9;
//   width: calc(100% - #{$sideBarWidth});
//   transition: width 0.28s;
// }

// .hideSidebar .fixed-header {
//   width: calc(100% - 54px);
// }

// .mobile .fixed-header {
//   width: 100%;
// }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue